// Copyright (c) 2019 Deere & Company

export function handleWarrantyLink() {

    this.actions.toggleWarrentyStatusModal(this.claim.claimType.key, true, this.claim.pin);
    this.actions.updateWarranties(this.claim.pin);

}

export function closeActiveWarrantyClaimModal() {

    this.actions.toggleWarrentyStatusModal(this.claim.claimType.key, false, '');

}



// WEBPACK FOOTER //
// ./src/claim/shared/services/warranty-modal-actions.js